import { Component, OnInit } from '@angular/core';
import { CandidateDataLoadState, ElectoralCoalitionDto, OverviewClient, ResultSummaryDto, ResultType } from '@shared/clients/api.generated';
import { MapAreasMapping } from '@shared/components/map/map-styles.model';
import { SidenavigationLink } from '@shared/components/sidenavigation/sidenavigation.model';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { ExtendedElectionDto, LatestUpdatesDistrictColumnDef, LatestUpdatesDistrictDto, PartyStatusColumnDef, PartyStatusDto } from '../election-overview.model';
import { ActivatedRoute, Router } from "@angular/router";
import { ElectionOverviewService } from "../election-overview.service";
import { TopCandidates } from "@shared/components/top-candidates/top-candidates.component";
import { SidenavigationLinkType } from "@shared/components/page-layout/page-layout.model";
import { MapAreaClickedEvent } from "@shared/components/map/map-events.model";


@Component({
  selector: 'valg-dk-ev-election-overview',
  templateUrl: './ev-election-overview.component.html'
})
export class EvElectionOverviewComponent implements OnInit {
  election?: ExtendedElectionDto;

  readonly SvgIcon = SvgIcon;
  public mapAreasMapping?: MapAreasMapping;

  links: SidenavigationLink[] = []

  sideNavTitleType = SidenavigationLinkType.NominationDistrict;
  parentLinkType = SidenavigationLinkType.Municipality;
  countStatus: { name: string, percentage: number }[] = [];
  countStatusUpdated: Date | undefined;
  resultType: ResultType = ResultType.NoResults;
  candidateDataLoadState: CandidateDataLoadState = CandidateDataLoadState.NotLoaded;
  electoralCoalitions: ElectoralCoalitionDto[] = [];


  latestUpdatesDistrictColumnDef = LatestUpdatesDistrictColumnDef;
  latestUpdates: LatestUpdatesDistrictDto[] = [];

  partyStatusColumnDef = PartyStatusColumnDef;
  partyStatus: PartyStatusDto[] = [];

  topCandidates: TopCandidates[] = [];
  resultSummary!: ResultSummaryDto;

  constructor(
    private readonly electionOverviewService: ElectionOverviewService,
    private readonly overviewClient: OverviewClient,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}


  async ngOnInit() {
    await this.initializeCurrentElection();
    this.initializeConstituency();
    this.initializeElectionOverview();
  }

  private async initializeCurrentElection() {
    this.election = await this.electionOverviewService.getCurrentElection();
  }

  private initializeConstituency() {
    this.overviewClient.getElectionSideNavigation().subscribe((result) => {
      this.links = this.electionOverviewService.mapConstituencies(result);
    });
  }

  private initializeElectionOverview() {
    this.electionOverviewService.getElectionOverviewData(this.overviewClient.getEvElectionOverview())
      .subscribe(({
         countStatus,
         resultType,
         countStatusUpdated,
         latestUpdates,
         partyStatus,
         topCandidates,
         mapAreaMapping,
         electoralCoalitions,
         candidateDataLoadState,
         resultSummary }) => {
        this.countStatus = countStatus;
        this.candidateDataLoadState = candidateDataLoadState;
        this.resultType = resultType;
        this.countStatusUpdated = countStatusUpdated;
        this.latestUpdates = latestUpdates;
        this.partyStatus = partyStatus;
        this.topCandidates = topCandidates;
        this.mapAreasMapping = mapAreaMapping;
        this.electoralCoalitions = electoralCoalitions ?? [];
        this.resultSummary = resultSummary;
      });
  }

  async onAreaClick($event: MapAreaClickedEvent) {
    const id = $event.data?.id;
    if (id) {
      const link = this.electionOverviewService.getNominationDistrictLink(id);
      await this.router.navigate([ link ], {
          relativeTo: this.route,
        }
      );
    }
  }
}
